/**
 * Formats a code string based on the specified case preference.
 *
 * @param code - The input code string to format
 * @param isUpperCase - Whether to preserve uppercase (true) or convert to lowercase (false)
 * @returns The formatted code string, or undefined if input is undefined
 *
 * @example
 * ```typescript
 * getNameCode('MyColumn', true)   // Returns: 'MyColumn'
 * getNameCode('MyColumn', false)  // Returns: 'mycolumn'
 * getNameCode(undefined, false)   // Returns: undefined
 * ```
 */
export const formatCodeByCase = (
	code: string | undefined,
	isUpperCase: boolean,
): string | undefined => {
	if (code === undefined) {
		return undefined
	}

	if (isUpperCase || isUpperCase === undefined) {
		return code
	}

	return code.toLowerCase()
}
